import _objectSpread from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/web.timers.js";
import "regenerator-runtime/runtime.js";
import { extractLoginData, getAccount } from "../unit/UserUtil";
import MarketList from "../components/MarketList.vue";
import { ElMessage, ElLoading } from "element-plus"; //import Chart from "../components/MarketComponents/Chart.vue";

import TradingChart from "../components/MarketComponents/TradingChart.vue";
import TradePanel from "../components/MarketComponents/TradePanel.vue";
import TransactionInfo from "../components/MarketComponents/TransactionInfo.vue";
import HistoryTable from "../components/MarketComponents/HistoryTable.vue";
import TradingOrderList from "../components/MarketComponents/TradingOrderList.vue";
import dsteem from "../unit/DsteemUtil";
import { toDecimal } from "../unit/public";
export default {
  components: {
    MarketList: MarketList,
    //Chart,
    TradePanel: TradePanel,
    TransactionInfo: TransactionInfo,
    HistoryTable: HistoryTable,
    TradingChart: TradingChart,
    TradingOrderList: TradingOrderList
  },
  data: function data() {
    return {
      market: {},
      account: {},
      points: 0,
      loginData: null,
      exchangeNum: 0,
      isLogining: false,
      isLogin: false,
      marketId: 0,
      userName: "",
      buyPrices: [
        /*   { price: 100, quantity: 10 },
        { price: 105, quantity: 15 }, */
      ],
      sellPrices: [
        /*         { price: 100, quantity: 10 },
        { price: 105, quantity: 15 }, */
      ],
      historyData: [
        /*   {
          id: 1,
          type: "buy",
          price: 100,
          quantity: 10,
          timestamp: "2025-01-01",
        },
        {
          id: 2,
          type: "sell",
          price: 105,
          quantity: 15,
          timestamp: "2025-01-02",
        },
        {
          id: 3,
          type: "buy",
          price: 110,
          quantity: 5,
          timestamp: "2025-01-03",
        }, */
      ],
      tradingData: [
        /*   {
            "id": 12013960,
            "created": "2025-02-16T13:49:12",
            "expiration": "2025-03-15T21:49:13",
            "seller": "boylikegirl",
            "orderid": 251998120,
            "for_sale": 1000,
            "sell_price": {
                "base": "1.000 SBD",
                "quote": "10.000 STEEM"
            },
            "real_price": "0.00000000000000000",
            "rewarded": false
        },
        {
           "id": 12013960,
            "created": "2025-02-16T13:49:12",
            "expiration": "2025-03-15T21:49:13",
            "seller": "boylikegirl",
            "orderid": 251998120,
            "for_sale": 1000,
            "sell_price": {
                "base": "1.000 SBD",
                "quote": "10.000 STEEM"
            },
            "real_price": "0.00000000000000000",
            "rewarded": false
        },
        {
            "id": 12013960,
            "created": "2025-02-16T13:49:12",
            "expiration": "2025-03-15T21:49:13",
            "seller": "boylikegirl",
            "orderid": 251998120,
            "for_sale": 1000,
            "sell_price": {
                "base": "1.000 SBD",
                "quote": "10.000 STEEM"
            },
            "real_price": "0.00000000000000000",
            "rewarded": false
        }, */
      ]
    };
  },
  methods: {
    loadAccount: function loadAccount() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loginData = extractLoginData();

                if (!_this.loginData) {
                  _context.next = 7;
                  break;
                }

                _this.isLogin = true;
                _this.userName = _this.loginData[0];
                _context.next = 6;
                return getAccount(_this.userName);

              case 6:
                _this.account = _context.sent;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    loadHistory: function loadHistory() {
      var _this2 = this;

      dsteem.getMarketHistoryApi().then(function (res) {
        _this2.historyData = [];
        var index = 1;
        res.forEach(function (item) {
          var isBuy = item.current_pays.indexOf("SBD") > -1;

          _this2.historyData.push({
            id: index,
            type: isBuy ? "buy" : "sell",
            price: isBuy ? (parseFloat(item.current_pays) / parseFloat(item.open_pays)).toFixed(6) : (parseFloat(item.open_pays) / parseFloat(item.current_pays)).toFixed(6),
            quantity: isBuy ? parseFloat(item.open_pays) : parseFloat(item.current_pays),
            timestamp: item.date.replace("T", " ")
          });

          index++;
        });
      });
    },
    loadTradingOrder: function loadTradingOrder() {
      var _this3 = this;

      dsteem.getOpenOrders(this.userName).then(function (res) {
        _this3.tradingData = [];
        var index = 1;
        res.forEach(function (item) {
          var isBuy = item.sell_price.base.indexOf("SBD") > -1 ? true : false;
          var price = isBuy ? parseFloat(item.sell_price.base) / parseFloat(item.sell_price.quote) : parseFloat(item.sell_price.quote) / parseFloat(item.sell_price.base);

          _this3.tradingData.push({
            id: item.id,
            type: isBuy ? "buy" : "sell",
            price: toDecimal(price, 3),
            steem: isBuy ? item.sell_price.quote : item.sell_price.base,
            sbd: isBuy ? item.sell_price.base : item.sell_price.quote,
            created: item.created.replace("T", " "),
            orderId: item.orderid,
            seller: item.seller
          });

          index++;
        });
      });
    },
    loadOrderBook: function loadOrderBook() {
      var _this4 = this;

      dsteem.getOrderBook().then(function (res) {
        var asks = res.asks; // 卖单

        var groupedAsks = {}; // Iterate through the sorted asks

        asks.forEach(function (ask) {
          var price = parseFloat(ask.real_price).toFixed(6);

          if (!groupedAsks[price]) {
            groupedAsks[price] = _objectSpread(_objectSpread({}, ask), {}, {
              quantity: 0
            }); // Initialize with the first ask
          }

          groupedAsks[price].quantity += parseFloat(ask.quantity); // Sum the quantities
        });
        asks = Object.values(groupedAsks);
        var bids = res.bids; // 买单

        var groupedBids = {}; // Iterate through the sorted asks

        bids.forEach(function (bid) {
          var price = parseFloat(bid.real_price).toFixed(6);

          if (!groupedBids[price]) {
            groupedBids[price] = _objectSpread(_objectSpread({}, bid), {}, {
              quantity: 0
            }); // Initialize with the first ask
          }

          groupedBids[price].quantity += parseFloat(bid.quantity); // Sum the quantities
        });
        bids = Object.values(groupedBids);
        var index = 1;
        _this4.sellPrices = []; // Sort asks by real_price in descending order

        asks.sort(function (a, b) {
          return parseFloat(b.real_price) - parseFloat(a.real_price);
        });
        asks.forEach(function (item) {
          _this4.sellPrices.push({
            price: parseFloat(item.real_price).toFixed(6),
            quantity: item.steem / 1000
          });
        });
        bids.forEach(function (item) {
          _this4.buyPrices.push({
            price: parseFloat(item.real_price).toFixed(6),
            quantity: item.steem / 1000
          });
        });
      });
    },
    finishTrade: function finishTrade() {}
  },
  mounted: function mounted() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this5.loadAccount();

            case 2:
              if (_this5.loginData) {
                _this5.currentUserName = _this5.loginData[0];
              } //获取交易历史,并且5秒刷新一次


              _this5.loadHistory();

              setInterval(function () {
                _this5.loadHistory();
              }, 5000);

              _this5.loadOrderBook();

              setInterval(function () {
                _this5.loadOrderBook();
              }, 5000);

              _this5.loadTradingOrder();

              setInterval(function () {
                _this5.loadTradingOrder();
              }, 5000);
              setInterval(function () {
                _this5.loadAccount();
              }, 5000);

              _this5.$bus.on("loginScuccess", function () {
                _this5.loadAccount();
              });

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
};